function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t\t.st0{fill:url(#SVGID_1_);}\n\t\t.st1{fill:url(#SVGID_2_);}\n\t");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M27,21.8H0.4L0,20.6c1.2-0.9,0.9-0.7,1.7-1.2H55l1.7,1.2l-0.4,1.2H29.7v33.5H27V21.8z M36.9,21.8v33.5h-2.7 V21.8 M22.4,21.8v33.5h-2.7V21.8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M28.3,3.3l25.2,18.3l-9.7,31.1H12.8L3.1,21.6L28.3,3.3 M28.3,0L0,20.6l10.8,34.8h35l10.8-34.8L28.3,0L28.3,0z"
});

var SvgLogoIconColor = function SvgLogoIconColor(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 55.4",
    style: {
      enableBackground: "new 0 0 56.7 55.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.3465,
    y1: 55.3906,
    x2: 28.3465,
    y2: 19.388
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E75BB"
    }
  }), React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#2088AC"
    }
  }), React.createElement("stop", {
    offset: 0.3806,
    style: {
      stopColor: "#23989C"
    }
  }), React.createElement("stop", {
    offset: 0.5651,
    style: {
      stopColor: "#26A48D"
    }
  }), React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#2AAD81"
    }
  }), React.createElement("stop", {
    offset: 0.8853,
    style: {
      stopColor: "#2CB378"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AB675"
    }
  })), _ref3, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.3465,
    y1: 55.3906,
    x2: 28.3465,
    y2: -9.094947e-13
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E75BB"
    }
  }), React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#2088AC"
    }
  }), React.createElement("stop", {
    offset: 0.3806,
    style: {
      stopColor: "#23989C"
    }
  }), React.createElement("stop", {
    offset: 0.5651,
    style: {
      stopColor: "#26A48D"
    }
  }), React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#2AAD81"
    }
  }), React.createElement("stop", {
    offset: 0.8853,
    style: {
      stopColor: "#2CB378"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2AB675"
    }
  })), _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoIconColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo--icon-color.01dcff83.svg";
export { ForwardRef as ReactComponent };